<template>
  <div id="timer" :class="{'timer-change': timer_status == 2}" v-if="show">
    <div id="small-timer-wrapper" class="small-timer-wrapper" :class="{'over-time-init': (over_time_ing || (suspend_time < 10 && suspend_time != undefined)) && resver_timer == 1,'black-end':timer_end }" v-show="timer_status == 2"  @click="initStatus" @mousedown="drag"  @touchstart="dragMobile" @touchmove="dragMobileMove">
      <div class="small-item" :class="{'end-font-size':timer_end}"><i v-if="!timer_end" v-html="small_big_timer_img"></i><span v-if="over_time_ing && !timer_end">超时</span>{{timer_end?'倒计时结束':''}}</div>
      <div class="small-item-cover"></div>
      <b @click="close('small')"></b>
    </div>
    <div class="big-screen-modal" :class="{'over-time-init': (over_time_ing || (suspend_time < 10 && suspend_time != undefined)) && resver_timer == 1,'white-end':timer_end }" v-show="timer_status == 3" @click="initStatus">
      <div class="big-item"><i v-html="small_big_timer_img"></i><span v-if="over_time_ing">超时</span>{{timer_end?'倒计时结束':''}}</div>
    </div>
    <div id='timer-wrapper' class='timer-wrapper' v-show="timer_status == 1">
        <div class='timer-header'>计时器<i class='timer-header-close' @click="close"></i></div>
        <div class='timer-tab'>
          <div class='arrive-timer' :class="{'timer-tab-active':resver_timer == 1}" @click="choose(1)">倒计时</div>
          <div class='main-timer' :class="{'timer-tab-active':resver_timer == 2}" @click="choose(2)">计时器</div>
        </div>
        <div class='timer-content'>
          <div class="timer-end" v-if="timer_end">倒计时结束</div>
          <div class='arrive-timer-content' v-if="!timer_end">
            <span class="over-time-span" v-if="over_time_ing">超时</span>

             <div class='item' v-if="resver_timer == 1">
                <div class='item-up' :class="{hidden:start_init}">
                  <span class='digit' @click="tool('first_value',1)" data-type='1'></span>
                  <span class='digit' @click="tool('second_value',1)" data-type='2'></span>
                  <span class='digit' @click="tool('third_value',1)" data-type='3'></span>
                  <span class='digit' @click="tool('four_value',1)" data-type='4'></span>
                </div>
                <div class='item-middle'>
                  <div id='count-down'>
                    <div class="init" v-if="resver_timer_init == 1">
                      <li class='first-digit'>{{first_value}}</li>
                      <li class='second-digit'>{{second_value}}</li>
                      <li class='colon'> : </li>
                      <li class='three-digit'>{{third_value}}</li>
                      <li class='four-digit'>{{four_value}}</li>
                    </div>
                    <div class="init" v-html="resver_timer_ing" :class="{'over-time-init': over_time_ing || (suspend_time < 10 && suspend_time != undefined)}" v-if="resver_timer_init == 2">
                      <!-- {{resver_timer_ing}} -->
                    </div>
                  </div>
                </div>
                <div class='item-bottom' :class="{hidden:start_init}">
                  <span class='digit' @click="tool('first_value',0)" data-type='5'></span>
                  <span class='digit' @click="tool('second_value',0)" data-type='6'></span>
                  <span class='digit' @click="tool('third_value',0)" data-type='7'></span>
                  <span class='digit' @click="tool('four_value',0)" data-type='8'></span>
                </div>
              </div>
              <div class='over-time-choose class_over_time_icon' :class="{'over-time-choose-active':over_time,'over-time-choose-forbid':start_init,'over-time-choose-forbid-icon':start_init && over_time}" v-if="resver_timer == 1" @click="overTime">
                <span class='over-time-choose-item'></span>
                <span class='over-time-choose-font'>超时记录</span>
              </div>

              <div class="main-timer-content" v-html="normal_timer_ing" v-if="resver_timer == 2">
                <!-- {{normal_timer_ing}} -->
              </div>

          </div>
        </div>
        <div class='timer-bottom'>
          <div class='screen-full' :class="{'screen-full-active':start}" @click="large">放大</div>
          <div class='play-or-stop' :class="{stop:start,'stop-style':timer_end}" @click="play"></div>
          <div class='reset' @click="reset">重置</div>
        </div>
      </div>
      <audio id="timer-audio" controls="controls"><source src="https://audio-download.qiniucdn.akadm.com/o_1cs6604hfdo91fn6o1d1gn1oka7.mp3" type="audio/mpeg"></audio>
  </div>
</template>

<script>
export default {
  name: "timer",
  data() {
    return {
      //是否显示计时器
      show: false,
      //计时器内部状态 1 倒计时   2 计时器
      resver_timer: 1,
      //倒计时时间调整  1 初始化状态    2 倒计时进行中
      resver_timer_init:1,
      //倒计时时间
      resver_timer_ing:`05<li class="colon"> : </li>00`,
      //计时器时间
      normal_timer_ing:`00<li class="colon"> : </li>00<li class="colon"> : </li>00`,
      //小屏或者大屏显示时间
      small_big_timer_img:'',
      //计时器显示状态  1 正常   2 小屏   3 大屏
      timer_status:1,
      //超时记录是否勾选状态
      over_time:true,
      //是否在超时
      over_time_ing:false,
      //是否开始过倒计时、计时器
      start_init:false,
      //开始、关闭状态
      start:false,
      //倒计时可调整的第1位数
      first_value:0,
      //倒计时可调整的第2位数
      second_value:5,
      //倒计时可调整的第3位数
      third_value:0,
      //倒计时可调整的第4位数
      four_value:0,
      //倒计时、计时器开始的时间（毫秒）
      start_time:0,
      //倒计时、计时器开始的时间（秒）
      start_second:0,
      //时事记录暂停时间
      suspend_time:undefined,
      //倒计时定时器
      timer_inter:null,
      //计时器定时器
      timer_inter_normal:null,
      //检测是否显示小屏计时器
      timer_dec:null,
      //检测是否显示小屏计时器秒数（超过三秒显示小屏）
      timer_dec_count:0,
      //倒计时结束
      timer_end:false,
      //移动端拖拽横坐标开始位置
      x:0,
      //移动端拖拽综坐标开始位置
      y:0,
      body_width:0,
      body_height:0,
      key:0,
      start_vesion:'',//开始版本
      stop_vesion:'',//结束版本
      down_timer_interval:null,
      down_timer_small:null,
      timer_start_timestamp: 0,
    };
  },
  props:['data'],
  watch: {
    data(val){
      this.public(val)
      this.resver_timer = 1;
      this.first_value = 0;
      this.second_value = 5;
      this.third_value = 0;
      this.four_value = 0;
      this.resver_timer_ing = '05:00';
      this.width = 0;
      this.height = 0;
      this.left = 0;
      this.top = 0;
      this.reset_fun();
    },
    start(val){
      console.log(val);
      if(val){
        if(this.resver_timer == 1){
          this.resver_timer_init = 2
        }
      }
    },
    timerData(val){//计时器数据
      if(this.key > 10){
          this.key = 0;
      }
        this.publicRec(val);
    },
    cutdownData(val){//倒计时数据
      if(this.key > 10){
          this.key = 0;
      }
      this.publicRec(val);
    }
  },
  computed: {
      cutdownData() {
          return this.$store.state.interaction.downtimer_data_receive ;
      },
      timerData() {
          return this.$store.state.interaction.timer_data_receive ;
      }
  },
  methods: {
    //获取屏幕高度和宽度
    gainBodyArea(){
      this.body_width = document.body.clientWidth - 30;
      this.body_height = document.body.clientHeight - 30;
      console.log(this.body_width);
      console.log(this.body_height);
    },
    //课堂互动拖拽事件
    drag(e){
        let oDiv = e.path[1];
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;
        let cookieX = e.clientX;
        let cookieY = e.clientY;
        this.gainBodyArea();
        const _this = this;
        document.onmousemove = function(e){
            e.preventDefault();
            let l = e.clientX - disX;
            let t = e.clientY - disY;
            if(l < -370 || t < -50 || l > _this.body_width || t > _this.body_height){
              return;
            }
            oDiv.style.left = l + "px"
            oDiv.style.top = t + "px"
            _this.$cookies.set("timer_small_left",l);
            _this.$cookies.set("timer_small_top",t);
        }
        document.onmouseup = function(e){
            if(e.clientX == cookieX && e.clientY == cookieY){
              _this.$cookies.set("drag_status",1)
            }else{
              _this.$cookies.set("drag_status",0)
            }
            document.onmousemove = null;
            document.onmouseup = null;
        }
    },
    //课堂互动拖拽事件(移动端)
    dragMobile(e){
        let touch;
        let oDiv = e.path[1];
        if(e.touches){//有可能对象在e上也有可能对象在e.touches[0]上
              touch = e.touches[0];
        }else {
              touch = e;
        }
        this.x = touch.clientX - oDiv.offsetLeft;
        this.y = touch.clientY - oDiv.offsetTop;
        this.gainBodyArea();
    },
    //课堂互动拖拽事件(移动端移动)
    dragMobileMove(e){
        let touch;
        let oDiv = e.path[1];
        if(e.touches){//有可能对象在e上也有可能对象在e.touches[0]上
            touch = e.touches[0];
        }else {
            touch = e;
        }
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = touch.clientX - this.x;
        let top = touch.clientY - this.y;
          if(left < -370 || top < -50 || left > this.body_width || top > this.body_height){
          return;
        }
        //移动当前元素
        oDiv.style.left = left + 'px';
        oDiv.style.top = top + 'px';
        this.$cookies.set("timer_small_left",left);
        this.$cookies.set("timer_small_top",top);
        e.preventDefault();//阻止页面的滑动默认事件
    },
    //父组件数据
    public(val){
      this.show = val;
        this.resver_timer_ing = this.first_value.toString() + this.second_value.toString()+ '<li class="colon"> : </li>' + this.third_value.toString() + this.four_value.toString();
        this.normal_timer_ing = `00<li class="colon"> : </li>00<li class="colon"> : </li>00`;
    },
    //选择计时器类型
    choose(type){
      if(this.resver_timer == type){
        return
      }
      this.resver_timer = type;
      if(type==1){
          this.$store.commit('downtimersendevent',this.key+'&event_down_timer_ready');
          // this.$store.commit('timersendevent',this.key+'&event_timer_close');//关闭计时器事件
      }else{
          this.$store.commit('timersendevent',this.key+'&event_timer_ready');
          // this.$store.commit('downtimersendevent',this.key+'&event_down_timer_close');
      }
        this.key++;
        this.$cookies.set("timer_small_item_status",type);
      this.reset_fun();
    },
    //调整倒计时时间
    tool(name,type){  //type 1 ++  0 --    最大数值为action的值 最小数值为0
      const action = {
        'first_value':5,
        'second_value':9,
        'third_value':5,
        'four_value':9,
      }
      if(type){
         if(this[name] == action[name]){
            return;
         }
         this[name]++
      }else{
        if(this[name] == 0 || (this.first_value == 0 && this.second_value == 0 && this.third_value == 0 && this.four_value == 3)){
          return;
        }
        this[name]--
      }
      if(this.first_value == 0 && this.second_value == 0 && this.third_value == 0 && this.four_value == 0){
        this.four_value = 3; //3秒为最小值
      }
      this.resver_timer_ing = this.first_value.toString() + this.second_value.toString()+ '<li class="colon"> : </li>' + this.third_value.toString() + this.four_value.toString();
    },
    //开始或者暂停计时器(倒计时、计时器)
    play_old(){
      if(this.timer_end){
        return;
      }
      this.start = !this.start;
      if(this.resver_timer == 1){
          if(this.start){
            this.timer();
          }else{
            clearInterval(this.down_timer_interval);
          }
          this.start_init = true;
      }
      if(this.resver_timer == 2){
         if(this.start){
            this.timer_normal();
          }else{
            clearInterval(this.timer_inter_normal);
          }
      }
      if(this.start){
        this.timingDetection();
        this.$flydata.flydataTrack(63);
      }else{
        this.timer_dec_count = 0;
        clearInterval(this.down_timer_small);
      }
    },
    //
    play(){
        if(this.timer_end){
            return;
        }
        this.start = !this.start;
        console.log(this.resver_timer,1111111111111);

        if(this.resver_timer == 1){
            if(this.start){
                if(this.key>0){
                    this.$store.commit('downtimersendevent',this.key+'&event_down_timer_continue');
                }else{
                    let time_long = this.$cookies.get(time_long)|| (parseInt(this.first_value.toString() + this.second_value.toString())*60 +parseInt(this.third_value.toString() + this.four_value.toString()))
                    this.$cookies.set('is_over_time',this.over_time);
                    // return;
                    this.$cookies.set('time_long',time_long)
                    this.$store.commit('downtimersendevent',this.key+'&event_down_timer_start');
                }
            }else{
                const audio=document.getElementById("timer-audio");
                audio.pause();
                this.$store.commit('downtimersendevent',this.key+'&event_down_timer_stop');
            }
            this.start_init = true;
        }
      if(this.resver_timer == 2){//计时器
         if(this.start){//开始
             if(this.key>0){
                 this.$store.commit('timersendevent',this.key+'&event_timer_continue');
             }else{
                 this.$store.commit('timersendevent',this.key+'&event_timer_start');
             }
          }else{//暂停
            if (!this.$cookies.get('timer_stop_time')) {
              this.$cookies.set('timer_stop_time', this.timer_start_timestamp);
            }
             
            this.$store.commit('timersendevent',this.key+'&event_timer_stop');
          }
      }
        this.key++ ;
    },
    //是否显示小屏计时显示
    timingDetection(){
        this.down_timer_small = setInterval(function(){
        if(this.timer_status != 3){
            if(this.timer_dec_count >2){
            this.timer_status = 2;
            this.$cookies.set("timer_small_status",2);
            document.getElementById("small-timer-wrapper").style.left = this.$cookies.get("timer_small_left") ? this.$cookies.get("timer_small_left") + "px" : document.body.clientWidth/2 - 200 +'px'
            document.getElementById("small-timer-wrapper").style.top = this.$cookies.get("timer_small_top") ? this.$cookies.get("timer_small_top") + "px" : document.body.clientHeight/2 - 80 +'px'
          }
          this.timer_dec_count++;
        }
      }.bind(this),1000)
    },
    //放大
    large(){
      if(!this.start){
        return;
      }
      this.timer_status = 3;
      this.$cookies.set("timer_small_status",3);
      this.$flydata.flydataTrack(64);
    },
    //回复初始状态
    initStatus(){
      if(this.timer_status == 2 && this.$cookies.get("drag_status") != 1){
         return;
      }else{
          console.log("click");
          this.timer_status = 1;
          this.timer_dec_count = 0;
          this.$cookies.set("timer_small_status",1);
      }
    },
    //时间计时(计时器)
    timer_normal_old(){
      console.log(this.suspend_time);
      this.start_second = this.suspend_time?this.suspend_time : 0;
      this.start_time = new Date().getTime();
      this.timer_inter_normal = setInterval(function(){
        let change_data =  parseInt((new Date().getTime() - this.start_time)/1000);
        let change_different = change_data + this.start_second;
        this.suspend_time = change_different;
        this.$cookies.set("timer_small_time",this.suspend_time);
        console.log(change_different);
        this.normal_timer_ing = this.change_time_normal(change_different);
        this.small_big_timer_img = this.normal_timer_ing;
      }.bind(this),30)
    },
    timer_normal(start_time,first_time){//start_time 当前开始时间戳  first_time 首次开始时间
        this.start = true;
        this.start_second = this.suspend_time?this.suspend_time : 0;//当前开始的秒数
        this.start_time = parseInt(start_time);
        this.timer_inter_normal = setInterval(function(){
            this.start_time++;
            let change_data =  parseInt(this.start_time - parseInt(first_time));
            // let change_different = change_data + this.start_second;
            this.suspend_time = change_data;
            this.$cookies.set("timer_small_time",change_data);
            this.$cookies.set("timer_stop_time",(parseInt(first_time)+change_data));
            console.log(change_data,111111);
            this.normal_timer_ing = this.change_time_normal(change_data);
            this.small_big_timer_img = this.normal_timer_ing;
        }.bind(this),1000)
    },
    //时间换算(时、分、秒)(计时器)
    change_time_normal(time){
        if(time > 86399){ // 89999 23:59:59 //超过时间则停止计时器
            this.$store.commit('timersendevent',this.key+'&event_timer_stop');
            clearInterval(this.timer_inter_normal);
            return;
        }
      let hour = parseInt(time / 3600);
      let minute = parseInt((time-hour*3600) / 60);
      let second = parseInt(time % 60);
      return `${hour > 9 ? hour: "0" + hour}<li class="colon"> : </li>${minute > 9 ? minute: "0" + minute}<li class="colon"> : </li>${second > 9 ? second: "0" + second}`;
    },
    //时间计时(倒计时)
    timer_old(){
      this.start_second = this.suspend_time?this.suspend_time : parseInt(this.first_value.toString() + this.second_value.toString())*60 +parseInt(this.third_value.toString() + this.four_value.toString());
      this.start_time = new Date().getTime();
      this.timer_inter = setInterval(function(){
        let change_data =  parseInt((new Date().getTime() - this.start_time)/1000);
        let change_different = this.start_second - change_data;
        this.suspend_time = change_different;
        this.$cookies.set("timer_small_time",this.suspend_time);
        console.log(change_different);
        this.resver_timer_ing = this.change_time(change_different);
        this.small_big_timer_img = this.resver_timer_ing;
      }.bind(this),30)
    },
    //时间计时(倒计时)
    timer(start_time,first_time,time_long){//change_data 上一次结束的时间戳
      this.start = true;
      this.start_second = this.suspend_time?this.suspend_time : parseInt(this.first_value.toString() + this.second_value.toString())*60 +parseInt(this.third_value.toString() + this.four_value.toString());
      this.start_time = parseInt(first_time)+parseInt(time_long) - parseInt(start_time) ;//开始的时间戳
      this.down_timer_interval = setInterval(function(){
          if(this.start_time<=0){
              if(this.over_time) {//开启超时记录
                  this.over_time_ing = this.over_time?true:false;
                  console.log(this.over_time_ing,1111111111111)
              }else{
                  this.start =false ;
                  this.timer_end =true;
                  this.$store.commit('downtimersendevent',this.key+'&event_down_timer_stop');
                  clearInterval(this.down_timer_interval);
              }
          }
        this.start_time--;
          // console.log(parseInt(first_time),parseInt(time_long) ,parseInt(start_time),this.start_time,66666666666)
        this.$cookies.set("timer_small_time",(parseInt(time_long) - this.start_time));
        // this.$cookies.set("timer_stop_time",change_different);
        this.resver_timer_ing = this.change_time(this.start_time);
        this.small_big_timer_img = this.resver_timer_ing;
      }.bind(this),1000)
        console.log('666666666666666666666666',this.down_timer_interval);
    },
    //时间换算(分、秒)(倒计时)
    change_time(time){
      if(time < 4 && time >0){ //最后三秒播放倒计时音频
          const audio=document.getElementById("timer-audio");
          audio.play();
      }
      console.log()
      if(time.toString().indexOf("-") > -1){
        time = parseInt(time.toString().replace("-",""));
        this.over_time_ing = true;
          // console.log(this.over_time_ing,22222222222)
      }
      if(time > 3599 || (time == 0 && !this.over_time)){  //3599S 59:59
        clearInterval(this.down_timer_interval);
        this.timer_end = true;
        return;
      }
      let second = parseInt(time % 60);
      let minute = parseInt(time / 60);
      return `${minute > 9 ? minute: "0" + minute}<li class="colon"> : </li>${second > 9 ? second: "0" + second}`;
    },
    //超时记录
    overTime(){
      if(this.start_init){
        return;
      }
      this.over_time = !this.over_time;
    },
    //重置
    reset_old(){
      this.resver_timer_init = 1;
      this.over_time = true;
      this.over_time_ing = false;
      this.start_init = false;
      this.start = false;
      this.start_time = 0;
      this.start_second = 0;
      this.suspend_time = undefined;
      this.timer_end = false;
      this.resver_timer_ing = this.first_value.toString() + this.second_value.toString()+ '<li class="colon"> : </li>' + this.third_value.toString() + this.four_value.toString();
      this.normal_timer_ing = `00<li class="colon"> : </li>00<li class="colon"> : </li>00`;
      this.small_big_timer_img = '';
      this.timer_status = 1;
      this.timer_dec_count = 0;
      clearInterval(this.down_timer_small);
      clearInterval(this.down_timer_interval);
      clearInterval(this.timer_inter_normal);
    },

  reset(){
      if(this.resver_timer == 1){
          this.$store.commit('downtimersendevent',this.key+'&event_down_timer_reset');
      }
      if(this.resver_timer == 2){//计时器
          this.$store.commit('timersendevent',this.key+'&event_timer_reset');
      }
      this.key++;
    },
    reset_fun(){
        this.resver_timer_init = 1;
        this.over_time_ing = false;
        this.start_init = false;
        this.start = false;
        this.start_time = 0;
        this.start_second = 0;
        this.key = 0;
        this.suspend_time = undefined;
        this.timer_end = false;
        this.resver_timer_ing = this.first_value.toString() + this.second_value.toString()+ '<li class="colon"> : </li>' + this.third_value.toString() + this.four_value.toString();
        this.normal_timer_ing = `00<li class="colon"> : </li>00<li class="colon"> : </li>00`;
        this.small_big_timer_img = '';
        this.timer_status = 1;
        this.timer_dec_count = 0;
        clearInterval(this.down_timer_small);
        clearInterval(this.down_timer_interval);
        clearInterval(this.timer_inter_normal);
    },

    //关闭
    close_old(type){
      this.show = false;
      this.$cookies.remove("timer_small_left");
      this.$cookies.remove("timer_small_top");
      clearInterval(this.down_timer_small);
      clearInterval(this.down_timer_interval);
      clearInterval(this.timer_inter_normal);
      this.$emit('watchChild',0);
      if(type == "small"){
        this.$flydata.flydataTrack(65);
      }
    },
  close(type){

      if(this.resver_timer == 1){
          this.$store.commit('downtimersendevent',this.key+'&event_down_timer_close_all');
      }
      if(this.resver_timer == 2){//计时器
          this.$store.commit('timersendevent',this.key+'&event_down_timer_close_all');
      }
      this.$cookies.set('close_type',type)
      this.key++;
    },
      //公共接受事件
    publicRec(parseData){
          const type = parseData.event_name;
          if(this.$cookies.get("timer_version")&&(this.$cookies.get("timer_version") != parseData.data.version)){
              console.log('版本不一致0000000000000')
              this.$cookies.set('timer_version',parseData.data.version);
          }
        //  教师不一致 或者 timer版本不一致 return
        if((this.$cookies.get("user_id") != parseData.data.user_id) ){
              return;
        }
        this.$cookies.set("event_id",parseData.data.event_id);
        const audio=document.getElementById("timer-audio");

        switch(type){
              /**********倒计时互动*********/
              case 'event_down_timer_ready'://----显示倒计时页面 -重置页面状态
                  this.key++;
                  this.$store.commit('timersendevent',this.key+'&event_timer_close');//关闭计时器事件
                  this.$cookies.set('timer_version',parseData.data.version);
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.show = true;
                  this.resver_timer = 1;
                  this.reset_fun();
                  console.log('倒计时准备状态0000000')
                  break;
              case 'event_down_timer_start'://开始倒计时--开始倒计时 -记录倒计时总时间，是否超时记录，改变倒计时状态
                  this.key++;
                  if(this.$cookies.get("timer_start_status")&&this.$cookies.get("timer_start_status")!=-1 && this.$cookies.get("timer_start_status")!=2){
                      console.log('开始倒计时============')
                      return;
                  }
                  this.show = true;
                  this.start = true ;
                  this.start_init = true;
                  this.resver_timer = 1;
                  this.over_time = parseData.data.is_over_time?true:false;
                  this.$cookies.set('time_long',parseData.data.time_long);
                  this.$cookies.set('is_over_time', this.over_time);
                  this.$cookies.set("timer_start_time",parseData.data.start_time);
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.timer(parseData.data.start_time,parseData.data.start_time,parseData.data.time_long);
                  this.timingDetection();
                  // this.$flydata.flydataTrack(63);
                  console.log('倒计时 开始  状态 11111111')

                  break;
              case 'event_down_timer_stop'://停止倒计时 暂停 记录倒计时的时间，记录暂停时间，改变倒计时状态
                  this.key++;
                  if(this.$cookies.get("timer_start_status")&&this.$cookies.get("timer_start_status")!=1 && this.$cookies.get("timer_start_status")!=4){
                      console.log('暂停倒计时~~~~~~~~~~~~~')
                      return;
                  }
                  this.show = true;
                  this.resver_timer = 1;
                  this.show = true;
                  this.start = false ;
                  this.timer_dec_count = 0 ;
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  let stop_time = parseInt(parseData.data.start_time)+parseInt(this.$cookies.get('timer_small_time'))
                  this.$cookies.set("timer_stop_time",stop_time);
                  clearInterval(this.down_timer_interval)
                  clearInterval(this.down_timer_small);
                  if(audio){
                      audio.pause();
                  }
                  // this.down_timer_small = null;
                  // this.down_timer_interval = null;
                  console.log('倒计时 暂停  状态 3333333',this.down_timer_interval);

                  break;
              case 'event_down_timer_continue'://继续倒计时 继续倒计时 - 改变倒计时状态，继续倒计时
                  this.key++;
                  // if(this.$cookies.get("timer_version") == parseData.data.version){
                  if(this.$cookies.get("timer_start_status")&&this.$cookies.get("timer_start_status")!=3){
                      console.log('继续使用倒计时-------------------')
                      return;
                  }
                  this.resver_timer = 1;
                  this.show = true;
                  this.start = true;
                  this.over_time = parseData.data.is_over_time?true:false;
                  this.$cookies.set('is_over_time', this.over_time);
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  let stop_time_c = parseInt(parseData.data.start_time)+parseInt(parseData.data.run_long||0)
                  this.timer(stop_time_c,parseData.data.start_time,parseData.data.time_long);
                  this.timingDetection();

                  console.log('倒计时 继续  状态 4444444')

                  break;
              case 'event_down_timer_close'://关闭倒计时--关闭所有倒计时事件
                  this.over_time_ing = false;
                  this.start = false ;
                  this.timer_dec_count = 0;
                  clearInterval(this.down_timer_small);
                  clearInterval(this.down_timer_interval);
                  clearInterval(this.timer_inter_normal)
                  break;

              case 'event_down_timer_reset'://重置倒计时
                  this.start_init = false;
                  this.show = true;
                  this.resver_timer = 1;
                  this.start = false;
                  this.timer_end = false;
                  this.over_time_ing = false;
                  this.over_time = true;
                  this.timer_dec_count = 0 ;
                  this.reset_cookies();
                  if(audio){
                      audio.currentTime = 0 ;
                      audio.pause();
                  }
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.$cookies.set('timer_version',parseData.data.version);
                  console.log('倒计时---------',this.down_timer_interval)

                  this.reset_fun();

                  break;
              /*************计时器互动***************/
              case 'event_timer_ready'://计时器准备状态
                  this.key++;
                  this.$store.commit('downtimersendevent',this.key+'&event_down_timer_close');//关闭倒计时事件
                  this.$cookies.set('timer_version',parseData.data.version);
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.show = true;
                  this.resver_timer = 2;
                  this.reset_fun();

                  break;
              case 'event_timer_start'://开始计时器
                  // if(this.$cookies.get("timer_version") == parseData.data.version ){
                  //     console.log('开始计时器=================')
                  //     return;
                  // }
                  this.start = true ;
                  this.show = true;
                  this.key++;
                  this.resver_timer = 2;
                  if(this.$cookies.get("timer_start_status")&&this.$cookies.get("timer_start_status")!=-1 && this.$cookies.get("timer_start_status")!=2){
                      console.log('开始计时器=================')
                      return;
                  }
                  this.$cookies.set("timer_version",parseData.data.version);
                  this.$cookies.set("timer_start_time",parseData.data.start_time);
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.start_vesion = parseData.data.version ;
                  this.timer_start_timestamp = parseData.data.start_time;
                  this.timer_normal(parseData.data.start_time,parseData.data.start_time);
                  this.timingDetection();
                  // this.$flydata.flydataTrack(63);
                  break;
              case 'event_timer_stop'://停止计时器
                  // if(this.$cookies.get("timer_version") == parseData.data.version){
                  //     // && this.$cookies.get("timer_start_status")==3
                  //     return;
                  // }
                  this.key++;
                  this.start = false;
                  this.show = true;
                  this.resver_timer = 2;
                  if(this.$cookies.get("timer_start_status")&&this.$cookies.get("timer_start_status")!=1 && this.$cookies.get("timer_start_status")!=4){
                      console.log('暂停计时器=================')
                      return;
                  }
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.stop_vesion = parseData.data.version ;
                  this.timer_status = 1 ;
                  clearInterval(this.timer_inter_normal);
                  this.timer_dec_count = 0;
                  clearInterval(this.down_timer_small);
                  break;
              case 'event_timer_continue'://继续计时器
                  // if(this.$cookies.get("timer_version") == parseData.data.version){
                  //     // && this.$cookies.get("timer_start_status")==4
                  //     return;
                  // }
                  this.key++;
                  this.show = true;
                  this.resver_timer = 2;
                  if(this.$cookies.get("timer_start_status")&&this.$cookies.get("timer_start_status")!= 3){
                      console.log('继续计时器=================')
                      return;
                  }
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  // console.log('继续计时器=================',parseData.data)
                  this.timer_normal(parseData.data.stop_time,parseData.data.start_time);
                  this.timingDetection();
                  break;
              case 'event_timer_close'://关闭计时器
                  // this.$cookies.set("timer_start_status",parseData.data.status);
                  // this.start = false;
                  // this.reset_cookies();
                  this.over_time_ing = false;
                  this.start = false ;
                  this.timer_dec_count = 0;
                  clearInterval(this.down_timer_small);
                  clearInterval(this.down_timer_interval);
                  clearInterval(this.timer_inter_normal)
                  break;
              case 'event_timer_reset'://重置计时器
                  this.show = true;
                  this.resver_timer = 2;
                  this.start = false ;
                  this.over_time_ing = false;
                  this.reset_cookies();
                  this.reset_fun();
                  this.$cookies.set("timer_start_status",parseData.data.status);
                  this.$cookies.set('timer_version',parseData.data.version);
                  break;
              case 'event_down_timer_close_all':////倒计时-关闭窗口事件 关闭所有计时器相关事件，清空所有状态
                  console.log('关闭所有事件------------')
                  this.show = false;
                  this.reset_cookies();
                  this.reset_fun();
                  this.$store.commit('timersendevent',this.key+'&event_timer_close');
                  this.$store.commit('downtimersendevent',this.key+'&event_down_timer_close');

                  break;
              default:
                  console.log("无该类型")
          }
  },
    reset_cookies(){
        this.$cookies.remove("timer_small_left");
        this.$cookies.remove("timer_small_top");
        this.$cookies.remove("timer_sma");
        this.$cookies.remove("timer_version");
        this.$cookies.remove("timer_small_time");
        this.$cookies.remove("timer_stop_time");
        this.$cookies.remove("timer_small_status");
        clearInterval(this.down_timer_small);
        clearInterval(this.down_timer_interval);
        clearInterval(this.timer_inter_normal)
    },
  },
  destroyed() {
      clearInterval(this.down_timer_small);
      clearInterval(this.down_timer_interval);
      clearInterval(this.timer_inter_normal);
  },
  created() {},
  components: {},
  mounted() {
      this.public(this.data);
      this.over_time = true;
      this.$cookies.remove("timer_small_left");
      this.$cookies.remove("timer_small_top");
      this.$cookies.remove("timer_version");
      this.$cookies.remove("timer_small_time");
      this.$cookies.remove("timer_stop_time");
      this.$cookies.remove("timer_start_time");
      this.$cookies.remove("timer_start_status");
      this.$cookies.remove("timer_small_status");
      return;
    if(this.$cookies.get("timer_small_status") == 2){
        this.show = true;
        this.timer_status = this.$cookies.get("timer_small_status");
        this.suspend_time = parseInt(this.$cookies.get("timer_small_time"));
        this.resver_timer = this.$cookies.get("timer_small_item_status")?this.$cookies.get("timer_small_item_status"):1;
        this.$nextTick(()=> {
            document.getElementById("small-timer-wrapper").style.left = this.$cookies.get("timer_small_left") ? this.$cookies.get("timer_small_left") + "px" : document.body.clientWidth/2 - 200 +'px';
            document.getElementById("small-timer-wrapper").style.top = this.$cookies.get("timer_small_top") ? this.$cookies.get("timer_small_top") + "px" : document.body.clientHeight/2 - 80 +'px';
        })
        this.play();
    }else{
      this.$cookies.remove("timer_small_left");
      this.$cookies.remove("timer_small_top");
      this.$cookies.remove("timer_version");
      this.$cookies.remove("timer_small_time");
      this.$cookies.remove("timer_stop_time");
      this.$cookies.remove("timer_start_time");
      this.$cookies.remove("timer_start_status");
      this.$cookies.remove("timer_small_status");
    }
  }
};
</script>

<style lang="scss" scoped>
    .timer-change {
        width: auto !important;
        height: auto !important;
    }
    #timer {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999999;
      width: 100%;
      height:100%;
      background: rgba($color: #000000, $alpha: 0.2);
      i {
        font-style: normal;
      }
      .hidden {
        -webkit-transition-duration: .4s;
        transition-duration: .4s;
        opacity: 0 !important;
      }
      .init {
        display: flex;
        display: -webkit-flex;
        width: 100%;
        height: 100%;
      }
      .timer-end {
        width: 100%;
        height:100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        font-size: 80px;
      }
      .over-time-init {
        color:#F04040 !important;
      }
      .black-end {
        color:#000000 !important;
      }
      .white-end {
        color: white !important;
      }
      /deep/.colon {
        display: inline-flex;
        align-items: center;
        height: 100%;
        padding-bottom: 0.15rem;
      }
      .big-screen-modal {
        @include fex-absolute-median;
        position: absolute;
        z-index: 9999999999;
        left: 0;
        top: 0;
        font-size: 3rem;
        letter-spacing: 0.5rem;
        width: 100%;
        height: 100%;
        color: #fff;
        background: #000000;
        cursor: pointer;
        .big-item {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 0.5rem;
          i {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
          }
          /deep/.colon {
            padding-bottom:0.6rem;
          }
          span {
            position: absolute;
            font-size: 1rem;
             letter-spacing: 0.2rem;
            left: -2.5rem;
            top: 2.3rem;
          }
        }
      }
      #timer-wrapper {
          background: #FFFFFF;
          box-shadow: 0 0 16px 0 rgba(0,0,0,0.50);
          position: absolute;
          left:calc(50% - 250px);
          top:calc(50% - 177px);
          z-index:9999999;
          width:500px;
          height:354px;
      }
      #timer-wrapper .timer-header {
          position: relative;
          height: 40px;
          line-height: 40px;
          background: #008BEF;
          font-size: 18px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
      }
      .timer-header .timer-header-close{
          position: absolute;
          right: 0;
          top: 0;
          width: 0.75rem;
          height: 100%;
          background: url(../../assets/images/pop_del_btn.png) no-repeat center center;
          // background-size: 0.75rem auto;
          cursor: pointer;
      }
      #count-down {
          /*float: left;*/
      }
      .timer-tab {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          height: 50px;
          font-size: 18px;
          color: #777777;
      }
      .timer-tab div {
          cursor: pointer;
          border-bottom: 4px solid #fff;
      }
      .timer-tab .arrive-timer {
          margin-right: 95px;
      }
      .timer-tab .timer-tab-active {
          font-size: 18px;
          color: #008BEF;
          border-bottom: 4px solid #008BEF;
      }
      #timer-wrapper .timer-content {
          height: 184px;
      }
      #timer-wrapper .timer-bottom {
          height: 80px;
          display: flex;
          display: -webkit-flex;
      }
      .arrive-timer-content {
          position: relative;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 100%;
          font-size: 80px;
          color: #444444;
          .over-time-span {
            position: absolute;
            left: 38px;
            top: 100px;
            font-size: 26px;
            color: #F04040;
          }
      }
      .arrive-timer-content .item {
          width: 274px;
          height: 100%;
      }
      .arrive-timer-content .item-up {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          position: relative;
          height: 54px;
      }
      .arrive-timer-content .item-middle {
          height: 76px;
          line-height: 76px;
          background: url(../../assets/images/time_bg.png) no-repeat center center;
          background-size: 100% 100%;
          font-size: 80px;
          color: #444444;
          overflow: hidden;
          letter-spacing: 11px;
          padding-left: 10px;
      }
      .arrive-timer-content .item-middle li {
          vertical-align: middle;
      }
      .arrive-timer-content .item-middle #count-down {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          height: 100%;
          width: 100%;
      }
      .arrive-timer-content .item-bottom {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          position: relative;
          height: 54px;
          padding-left: 2px;
      }
      .arrive-timer-content .digit {
          display: inline-block;
          width: 34px;
          height: 22px;
          background: #FFFFFF;
          border: 1px solid #AAAAAA;
          border-radius: 11px;
      }
      .digit:nth-of-type(1) {
          margin-left: 15px;
      }
      .digit:nth-of-type(2) {
          margin-left: 23px;
      }
      .digit:nth-of-type(3) {
          margin-left: 55px;
      }
      .digit:nth-of-type(4) {
          margin-left: 23px;
      }
      .arrive-timer-content .item-up .digit {
          background: url(../../assets/images/add_time_icon.png) no-repeat center center;
          cursor: pointer;
      }
      .arrive-timer-content .item-bottom .digit {
          background: url(../../assets/images/subtract_time_icon.png) no-repeat center center;
          cursor: pointer;
      }
      .timer-bottom .screen-full {
          display: inline-block;
          width: 78px;
          height: 30px;
          line-height: 30px;
          background: #FFFFFF;
          border: 1px solid #D9D9D9;
          border-radius: 4px;
          font-size: 16px;
          color: #D9D9D9;
          padding-left: 36px;
          background: url(../../assets/images/full_display_enabled_icon.png) no-repeat 8px center;
          margin-left: 70px;
          margin-top: 30px;
          cursor: pointer;
      }
      .timer-bottom .screen-full-active {
          color: #777777;
          border: 1px solid #777777;
          background: url(../../assets/images/full_display_icon.png) no-repeat 8px center;
      }
      .timer-bottom .play-or-stop {
          display: inline-block;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin: 0 72px;
          cursor: pointer;
          background: #008BEF url(../../assets/images/play_icon.png) no-repeat center center;
      }
      .timer-bottom .stop {
          background: #008BEF url(../../assets/images/suspend_icon.png) no-repeat center center;
      }
      .timer-bottom .reset {
          display: inline-block;
          width: 78px;
          height: 30px;
          line-height: 30px;
          background: #FFFFFF;
          border: 1px solid #777777;
          border-radius: 4px;
          font-size: 16px;
          color: #777777;
          padding-left: 36px;
          background: url(../../assets/images/resert_icon.png) no-repeat 8px center;
          margin-top: 30px;
          cursor: pointer;
      }
      .timer-tool-hidden {
          visibility: hidden;
      }
      /*计时器覆盖小弹框*/
      .small-timer-wrapper {
          /*display: flex;*/
          /*display: -webkit-flex;*/
          /* visibility: hidden; */
          padding-left: 10px;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: calc(50% - 200px);
          top: calc(50% - 40px);
          width: 400px;
          height: 80px;
          background: #FFFFFF;
          box-shadow: 0 0 16px 0 rgba(0,0,0,0.50);
          border-radius: 8px;
          font-size: 80px;
          color: #444444;
          /* line-height: 120px; */
          text-align: center;
          letter-spacing: 11px;
          z-index: 99999999;
          cursor: pointer;
          b {
            position: absolute;
            right: 0;
            top:-0.46rem;
            display: inline-block;
            width: 0.46rem;
            height: 0.46rem;
            background: url("../../assets/images/inter_lock_close1.png") center center no-repeat;
          }
      }
      .overtime-active {
          padding-left: 65px;
      }
      .overtime-active:after {
          content:"超时";
          position: absolute;
          left: 30px;
          bottom: 1px;
          font-size: 26px;
          letter-spacing: 0px;
      }
      #big_over_time {
          position: absolute;
          display: inline-block;
          left: -761px;
          bottom: 71px;
          font-size: 104px;
          letter-spacing: 0px;
      }
      .small-timer-wrapper .colon {
          display: inline-block;
          color: #777777;
          font-size: 80px;
          padding-bottom: 17px;
          vertical-align: middle;
      }
      .main-timer-content {
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
          display: flex;
          display: -webkit-flex;
          font-size: 80px;
          color: #444444;
          cursor: pointer;
          letter-spacing: 11px;
      }
      #timer-wrapper .item-middle-active {
          color: #F04040;
      }
      .item-middle-active .colon{
          color: #F04040;
      }
      .arrive-timer-content .item-middle-active #count-down .colon {
          color: #F04040;
      }
      .small-timer-wrapper.item-middle-active {
          color: #F04040;
      }
      .small-timer-wrapper.small-font-active {
          font-size: 57px;
      }
      .small-timer-wrapper .colon {
          display: inline-block;
      }
      .main-timer-content .colon {
          display: inline-block;
          margin-bottom: 14px;
          color: #777777;
      }
      .small-timer-wrapper.screen-full-wrap {
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          font-size: 320px;
          color: #fff;
          background: black;
          letter-spacing: 50px;
          border-radius: 0;
          transform: translate(0px,0px) !important;
      }
      .small-timer-wrapper.screen-full-wrap .colon{
          font-size: 320px;
          color: #fff;
          margin-bottom: 40px;
      }
      .screen-full-wrap.small-font-active {
          font-size: 250px;
      }
      @media (max-width: 1650px) {
          .small-timer-wrapper.screen-full-wrap {
              font-size: 250px;
          }
          .small-timer-wrapper.screen-full-wrap .colon{
              font-size: 250px;
              margin-bottom: 30px;
          }
          .screen-full-wrap.small-font-active {
              font-size: 200px;
          }
          .screen-full-wrap #over_time {
              left: -770px;
              top: 105px;
              font-size: 104px;
          }
      }

      @media (max-width: 1420px) {
          .small-timer-wrapper.screen-full-wrap {
              font-size: 200px;
          }
          .small-timer-wrapper.screen-full-wrap .colon{
              font-size: 200px;
          }
      }

      @media (max-width: 1250px) {
          .small-timer-wrapper.screen-full-wrap {
              font-size: 150px;
          }
          .small-timer-wrapper.screen-full-wrap .colon{
              font-size: 150px;
              margin-bottom: 15px;
          }
      }

      @media (max-width: 1000px) {
          .small-timer-wrapper.screen-full-wrap {
              font-size: 140px;
              letter-spacing: 25px;
          }
          .small-timer-wrapper.screen-full-wrap .colon{
              font-size: 140px;
              margin-bottom: 10px;
          }
      }
      @media (max-width: 820px) {
          .small-timer-wrapper.screen-full-wrap {
              font-size: 120px;
              letter-spacing: 14px;
          }
          .small-timer-wrapper.screen-full-wrap .colon{
              font-size: 120px;
          }
          .screen-full-wrap.small-font-active {
              font-size: 90px;
          }
      }

      .item-middle-active.screen-full-wrap {
          color: #F04040;
      }
      .item-middle-active.screen-full-wrap .colon{
          color: #F04040;
      }
      .timer-bottom .stop-style {
          background: #AAAAAA url(../../assets/images/play_icon.png) no-repeat center center;
      }
      .timer-cover-modal {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.40);
          position: relative;
          z-index: 10401;
      }
      #timer-audio {
          display: none;
      }
      .small-timer-wrapper {
       /deep/.small-item {
         position: relative;
         height:100%;
         i {
          height: 100%;
          font-size: 0.6rem;
          display: flex;
          line-height: 1;
          align-items: center;
          justify-content: center;
          vertical-align: middle;
         }
          .colon {
            padding-bottom: 0.15rem;
          }
          span {
            position: absolute;
            left: 0.1rem;
            letter-spacing: 0;
            top: 0.3rem;
            font-size: 0.3rem;
          }
        }
        .small-item-cover {
           position: absolute;
           top:0;
           left: 0;
           cursor: move;
           width: 100%;
           height: 100%;
         }
         .end-font-size {
           font-size: 0.56rem;
         }
      }
      .small-timer-wrapper #over_time {
          display: inline-block;
          width: auto;
          height: auto;
          /* position: absolute; */
          /* left: 20px;
          top: 20px; */
          font-size: 26px;
          letter-spacing: 0px;
          margin-right: 10px;
          /* padding-top: 40px; */
      }
      .item-middle  #over_time {
          position: absolute;
          left: 38px;
          top: 168px;
          font-size: 26px;
          letter-spacing: 0px;
      }
      .screen-full-wrap .colon {
          position: relative;
      }
      .screen-full-wrap #over_time {
          position: absolute;
          display: inline-block;
          left: -750px;
          top: 105px;
          font-size: 104px;
          color: #F04040;
          letter-spacing: 0;
      }
      @media (max-width: 1650px) {
          #big_over_time {
              left: -641px;
              bottom: 52px;
          }
      }

      @media (max-width: 1420px) {
          #big_over_time {
              left: -548px;
              bottom: 39px;
              font-size: 84px;
          }
      }

      @media (max-width: 1250px) {
          #big_over_time {
              left: -436px;
              bottom: 34px;
              font-size: 64px;
          }
      }

      @media (max-width: 1000px) {
          #big_over_time {
              left: -350px;
              bottom: 34px;
              font-size: 54px;
          }
      }
      @media (max-width: 820px) {
          #big_over_time {
              left: -280px;
              bottom: 33px;
              font-size: 44px;
          }
      }

      @media (max-width: 680px) {
          #big_over_time {
              left: -641px;
              bottom: 52px;
          }
      }
      .over-time-choose {
          position: absolute;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          right: 56px;
          top: 176px;
          font-size: 16px;
          overflow: hidden;
          cursor: pointer;
      }
      .over-time-choose-item {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          margin-right: 8px;
      }
      .over-time-choose-font {
          display: inline-block;
          font-size: 16px;
          color: #777777;
          margin-bottom: 2px;
      }
      .over-time-choose-active .over-time-choose-item {
          background: url(../../assets/images/over_time_icon.png) no-repeat center center;
      }
      .over-time-choose-forbid-icon .over-time-choose-item{
          background: url(../../assets/images/over_time_enabled_icon.png) no-repeat center center !important;
      }
      .over-time-choose-forbid-icon span {
        color:#eeeeee;
      }
      .over-time-choose-forbid .over-time-choose-item {
          border: 1px solid #eeeeee;
      }
      .over-time-choose-forbid .over-time-choose-font {
          color: #eeeeee;
      }
      @media screen and (max-width: 1700px) {
        .big-screen-modal {
          font-size: 2.5rem;
          .big-item span {
            font-size: 0.8rem;
            letter-spacing: 0;
            left: -1.8rem;
            top: 2rem;
          }
        }
      }
       @media screen and (max-width: 1400px) {
        .big-screen-modal {
          font-size: 2rem;
          .big-item span {
            font-size: 0.6rem;
            left: -1.2rem;
            letter-spacing: 0;
            top: 1.8rem;
          }
        }
      }
       @media screen and (max-width: 1150px) {
        .big-screen-modal {
          font-size: 1.5rem;
          .big-item span {
            font-size: 0.6rem;
            left: -1rem;
            letter-spacing: 0;
            top: 1.1rem;
          }
            /deep/.big-item .colon {
            padding-bottom: 0.35rem;
          }
        }
      }
        @media screen and (max-width: 950px) {
        .big-screen-modal {
          font-size: 1rem;
          .big-item span {
            font-size: 0.4rem;
            left: -0.8rem;
            letter-spacing: 0;
            top: 0.7rem;
          }
           /deep/.big-item .colon {
            padding-bottom: 0.2rem;
          }
        }
      }
       @media screen and (max-width: 770px) {
        .big-screen-modal {
          font-size: 0.6rem;
          .big-item span {
            font-size: 0.3rem;
            left: -0.6rem;
            letter-spacing: 0;
            top: 0.35rem;
          }
        /deep/.big-item .colon {
            padding-bottom: 0.1rem;
          }
        }
      }
    }
</style>
